<div class="pt-6" id="topContainer">
  <div class="p-2 ">
    <h3 [ngClass]="'text-'+globals.colorTheme">
      <i class=" material-icons">house</i>
      Home
    </h3>
  </div>
</div>
<mat-divider></mat-divider>
<br>
<div class="container">
  <div class="row">
    <div class="col tile-right">
      <mat-card appearance="outlined" class="mainMenu-card ta-home-sales text-center" routerLink="/booking">
        <br>
        <i class="material-icons font_60">book</i>
        <!-- <br> -->
        <span>Sales</span>
      </mat-card>
    </div>
    <div class="col tile-left">
      <mat-card appearance="outlined" *ngIf="isSalesOrderAllow" class="mainMenu-card ta-home-order text-center " routerLink="/order">
        <br>
        <i class="material-icons font_60">menu_book</i>
        <!-- <br> -->
        <span>Order</span>
      </mat-card>
      <mat-card appearance="outlined" *ngIf="!isSalesOrderAllow" class="disabledMainMenu-card  text-center " disabled text-center>
        <br>
        <i class="material-icons font_60">menu_book</i>
        <!-- <br> -->
        <span>Order</span>
      </mat-card>
    </div>
  </div>
  <div class="row">
    <div class="col tile-right">
      <mat-card appearance="outlined" class="mainMenu-card ta-home-quantities text-center " routerLink="/items" text-center>
        <br>
        <i class="material-icons font_60">shopping_basket</i>
        <!-- <br> -->
        <span>Quantities</span>
      </mat-card>
    </div>
    <div class="col tile-left">
      <mat-card appearance="outlined" *ngIf="isBookAllow" class="mainMenu-card ta-home-quotes text-center " routerLink="/quotes" text-center>
        <br>
        <i class="material-icons font_60">credit_card</i>
        <!-- <br> -->
        <span>{{QuoteButtonName}}</span>
      </mat-card>
      <mat-card appearance="outlined" *ngIf="!isBookAllow" class="disabledMainMenu-card  text-center " disabled text-center>
        <br>
        <i class="fas fa-money-check-alt fa-w-18 fa-3x"></i>
        <!-- <br> -->
        <span>{{QuoteButtonName}}</span>
      </mat-card>
    </div>
  </div>
    <div class="row">
      <div class="col tile-right">
        <mat-card appearance="outlined" class="mainMenu-card ta-home-settings text-center " routerLink="/settings">
          <br>
          <i class="material-icons font_60">settings</i>
          <!-- <br> -->
          <span>Settings</span>
        </mat-card>
      </div>
      <div class="col tile-left">
        <mat-card *ngIf="isProUser"  appearance="outlined" class="mainMenu-card ta-home-history text-center " routerLink="/history">
          <br>
          <i class="material-icons font_60">history</i>
         
          <span>History</span>
        </mat-card>
        <mat-card *ngIf="!isProUser"  appearance="outlined" class="disabledMainMenu-card  text-center " disabled text-center>
          <br>
          <i class="material-icons font_60">history</i>        
          <span>History</span>
        </mat-card>
      </div>
    </div>
  </div>